import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import React from 'react'
import Grid from '@mui/material/Grid'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import Button from '@mui/material/Button'
import { Controller } from 'react-hook-form'
import { Step4Props } from '../types'
import useStyles from '../styles/Step4.styles'
import FormItem from '../../../hoc/FormItem'
import { Alert, CircularProgress, Divider, FormLabel, MenuItem, Typography } from '@mui/material'
import HelperModal from '../../../hoc/HelperModal'
import { ReactionTypeDesc } from '../constants'
import { useGtmPageView } from '../../hooks'
import TagManager from 'react-gtm-module'
import { DndContext, DragEndEvent, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, arrayMove, rectSortingStrategy } from '@dnd-kit/sortable'
import { ContactItem } from '../components/ContactItem'

const Step4View: React.FC<Step4Props> = ({
    form,
    options,
    onStepBack,
    isUpdating,
    activationObject,
    conditions: { canEditcanEditAppMyJablotronEmail },
}) => {
    const classes = useStyles()
    const { control, formState, handleSubmit, watch, setValue } = form.form
    const { errors } = formState
    const complyWithGuidlinesValue = watch('complyWithGuidelines')
    const contactItems = watch('personContacts')

    //const { enqueueSnackbar } = useSnackbar()
    // React.useEffect(() => {
    //     if (options.error) enqueueSnackbar('Chyba při načítání seznamu PSČ: ' + options.error, { variant: 'error' })
    // }, [enqueueSnackbar, options.error])

    useGtmPageView({ pageName: 'Step4', synonym: activationObject?.synonym })

    const sensors = useSensors(useSensor(PointerSensor))

    const onDragEnd = (event: DragEndEvent) => {
        const { active, over } = event

        if (!contactItems) return

        if (active.id !== over?.id) {
            const oldIndex = form.contactPersons.fields.findIndex((item) => item.id === active.id)
            const newIndex = form.contactPersons.fields.findIndex((item) => item.id === over?.id)
            const newArray = arrayMove(form.contactPersons.fields, oldIndex, newIndex)

            const newOrderedArray = newArray.map((item, index) => ({ ...item, order: index }))

            setValue('personContacts', newOrderedArray)
        }
    }

    return (
        <form onSubmit={handleSubmit(form.onSubmit)} method='post' autoComplete='off'>
            <Box p={2} maxWidth={1050}>
                <Box p={1} paddingBottom={{ sm: 0 }}>
                    <Typography fontSize={{ xs: '1.2rem', sm: '1.973rem' }} variant='h4'>
                        REAKCE TÍSŇOVÉ LINKY NA ZPRÁVY Z OBJEKTU
                    </Typography>
                </Box>
                <Box p={1} paddingTop={0} fontSize={'0.875rem'} textAlign={'left'}>
                    <Typography variant='body1' paragraph>
                        Zde máte uvedené pokyny, podle kterých budou naši operátoři v případě níže uvedených situací reagovat. V
                        případě, že máte zájem o jiné pokyny, budeme Vás kontaktovat po dokončení aktivace.
                    </Typography>
                </Box>
                <Divider />
                <Box p={1}>
                    <Grid container spacing={{ xs: 0, md: 0 }} alignItems='flex-start' marginBottom={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='h6'>Poplach</Typography>
                        </Grid>
                        <Grid item xs={11} md={9.5}>
                            <Typography className={classes.reactionBox} variant='body1'>
                                {ReactionTypeDesc['Alert']}
                            </Typography>
                        </Grid>
                        <Grid textAlign='right' item xs={1} md={0.5}>
                            <HelperModal textKey='INSTRUCTION_ALARM' />
                        </Grid>
                    </Grid>
                    <Grid container spacing={{ xs: 0, md: 0 }} alignItems='flex-start' marginBottom={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='h6'>Panika</Typography>
                        </Grid>
                        <Grid item xs={11} md={9.5}>
                            <Typography className={classes.reactionBox} variant='body1'>
                                {ReactionTypeDesc['Panic']}
                            </Typography>
                        </Grid>
                        <Grid textAlign='right' item xs={1} md={0.5}>
                            <HelperModal textKey='INSTRUCTION_PANIC' />
                        </Grid>
                    </Grid>
                    <Grid container spacing={{ xs: 0, md: 0 }} alignItems='center' marginBottom={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='h6'>Porucha</Typography>
                        </Grid>
                        <Grid item xs={11} md={9.5}>
                            <Typography className={classes.reactionBox} variant='body1'>
                                {ReactionTypeDesc['Failure']}
                            </Typography>
                        </Grid>
                        <Grid textAlign='right' item xs={1} md={0.5}>
                            <HelperModal textKey='INSTRUCTION_FAULT' />
                        </Grid>
                    </Grid>
                    <Grid container spacing={{ xs: 0, md: 0 }} alignItems='center' marginBottom={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='h6'>Ztráta spojení</Typography>
                        </Grid>
                        <Grid item xs={11} md={9.5}>
                            <Typography className={classes.reactionBox} variant='body1'>
                                {ReactionTypeDesc['ConnectionLost']}
                            </Typography>
                        </Grid>
                        <Grid textAlign='right' item xs={1} md={0.5}>
                            <HelperModal textKey='INSTRUCTION_LOSSES' />
                        </Grid>
                    </Grid>
                </Box>
                <Divider />

                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid item xs={12} sm={8} md={3}>
                        <FormItem>
                            <FormLabel>
                                Vyhovují Vám pokyny?&nbsp;
                                <HelperModal textKey='INSTRUCTION_AGREE' />
                            </FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} sm={7} md={9}>
                        <FormItem>
                            <Controller
                                name={'complyWithGuidelines'}
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <RadioGroup {...field} row onChange={(e, val) => field.onChange(val === 'true')}>
                                            <FormControlLabel value={true} control={<Radio color='primary' />} label='Ano' />
                                            <FormControlLabel value={false} control={<Radio color='primary' />} label='Ne' />
                                        </RadioGroup>
                                    </>
                                )}
                            />
                        </FormItem>
                    </Grid>
                    {complyWithGuidlinesValue ? null : (
                        <Grid item xs={12} marginBottom={2}>
                            <Alert severity='info'>Aktivace bude ukončena po stisku tlačítka "POKRAČOVAT".</Alert>
                        </Grid>
                    )}
                </Grid>
                <Grid container spacing={{ xs: 2, md: 3 }} marginBottom={2}>
                    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
                        <SortableContext items={form.contactPersons.fields} strategy={rectSortingStrategy}>
                            {form.contactPersons.fields.map((field, index) => (
                                <ContactItem
                                    field={field}
                                    key={field.id}
                                    id={field.id}
                                    index={index}
                                    classes={classes}
                                    form={form}
                                    options={options}
                                />
                            ))}
                        </SortableContext>
                    </DndContext>
                </Grid>
                <Grid container spacing={{ xs: 0, md: 0 }} marginBottom={2}>
                    <Grid item xs={12} textAlign='right'>
                        {errors.personContacts && !Array.isArray(errors.personContacts) && (
                            <Alert variant='filled' severity='warning'>
                                Minimálně jedna kontaktní osoba musí být Administrátor
                            </Alert>
                        )}
                        {form.contactPersons.fields.length < 4 && form.contactPersons.fields && (
                            <Button
                                variant='contained'
                                color='primary'
                                size='small'
                                onClick={() => form.contactPersons.add(form.contactPersons.fields?.length)}
                            >
                                <PersonAddIcon></PersonAddIcon>&ensp; Přidat kontaktní osobu
                            </Button>
                        )}
                    </Grid>
                </Grid>

                <Grid className={classes.longLabelText} container spacing={{ xs: 0, md: 0 }} rowSpacing={1} marginBottom={2}>
                    <Grid item xs={12} md={4}>
                        <FormItem marginTop={{ xs: '10px', md: 0 }}>
                            <FormLabel>
                                Heslo pro komunikaci s Tísňovou linkou&nbsp;
                                <HelperModal textKey='PASSWORD_PHONE_CONTATCT' />
                            </FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <FormItem>
                            <Controller
                                name={'comunicationPassword'}
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        onChange={(e) => {
                                            const inputValue = e.target.value
                                            const nullableString = inputValue === '' ? null : inputValue
                                            field.onChange(nullableString)
                                        }}
                                        value={field.value || ''}
                                        fullWidth
                                        inputProps={{ style: { textTransform: 'uppercase' } }}
                                        variant='outlined'
                                        type='text'
                                        error={errors.comunicationPassword !== undefined}
                                        helperText={errors.comunicationPassword?.message}
                                    />
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 0, md: 0 }} rowSpacing={1} marginBottom={2}>
                    <Grid item xs={12} md={4}>
                        <FormItem>
                            <FormLabel>
                                Uživatelské jméno pro aplikaci MyJABLOTRON&nbsp;
                                <HelperModal textKey='EMAIL_MYJABLOTRON' />
                            </FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <FormItem>
                            <Controller
                                name={'appMyJablotronEmail'}
                                control={control}
                                render={({ field }) => (
                                    <>
                                        {canEditcanEditAppMyJablotronEmail && (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                select
                                                error={errors.appMyJablotronEmail !== undefined}
                                                helperText={errors.appMyJablotronEmail?.message}
                                            >
                                                {options.jablotronAppEmails.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}
                                        {!canEditcanEditAppMyJablotronEmail && (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                error={errors.appMyJablotronEmail !== undefined}
                                                helperText={errors.appMyJablotronEmail?.message}
                                                disabled
                                            ></TextField>
                                        )}
                                    </>
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                <Box paddingTop={2} className={classes.flex}>
                    <Button variant='outlined' onClick={() => onStepBack()}>
                        &#60; Zpět
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        disabled={isUpdating}
                        startIcon={isUpdating && <CircularProgress size={20} />}
                        onClick={() => {
                            TagManager.dataLayer({
                                dataLayer: {
                                    event: 'clickNext',
                                },
                            })
                        }}
                    >
                        Pokračovat &#62;
                    </Button>
                </Box>
            </Box>
        </form>
    )
}

export default Step4View
